/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
/* eslint-disable no-param-reassign */
import { api } from "jiffy-api";
import { createJotaiPiniaFacadeForReact } from "common/vue/createJotaiPiniaFacadeForReact";
import {
  jotaiStore,
  SPANGLE_MODES,
  lastSpangledDimensionsAtom,
  spangleVariationsAtom,
  spangleModeAtom,
  selectedAlgorithmAtom,
  originalArtworkUrlAtom,
  spanglesMaxImageCountAtom,
  allAPIsCompletedStateAtom,
  invalidSpangleSelectedAtom,
  isSpangleReorderingAtom,
  completedSpangleDataAtom
} from "./spangles-module.atoms";
// eslint-disable-next-line import/no-cycle
import { dtfStore } from "./store";

export { SPANGLE_MODES };

const lastSpangledDimensionsDefault = { width: null, height: null };
const defaultVariation = { isLoading: true };

// @ts-expect-error TS(6133): 'initialState' is declared but its value is never ... Remove this comment to see the full error message
// eslint-disable-next-line no-unused-vars
const initialState = {
  lastSpangledDimensions: lastSpangledDimensionsDefault,
  spangleVariations: [],
  spangleMode: SPANGLE_MODES.spangleIt,
  selectedAlgorithm: null,
  originalArtworkUrl: "",
  spanglesMaxImageCount: 1,
  allAPIsCompletedState: true,
  invalidSpangleSelected: false,
  isSpangleReordering: false,
  completedSpangleData: []
};

export const useSpanglesStore = createJotaiPiniaFacadeForReact({
  // @ts-expect-error TS(2322): Type 'Store' is not assignable to type 'JotaiStore... Remove this comment to see the full error message
  jotaiStore,

  state: {
    lastSpangledDimensions: lastSpangledDimensionsAtom,
    spangleVariations: spangleVariationsAtom,
    spangleMode: spangleModeAtom,
    selectedAlgorithm: selectedAlgorithmAtom,
    originalArtworkUrl: originalArtworkUrlAtom,
    spanglesMaxImageCount: spanglesMaxImageCountAtom,
    allAPIsCompletedState: allAPIsCompletedStateAtom,
    invalidSpangleSelected: invalidSpangleSelectedAtom,
    isSpangleReordering: isSpangleReorderingAtom,
    completedSpangleData: completedSpangleDataAtom
  },

  getters: {
    spangleIt() {
      // @ts-expect-error TS(4111): Property 'spangleMode' comes from an index signatu... Remove this comment to see the full error message
      return this.spangleMode === SPANGLE_MODES.spangleIt;
    },
    spangleSizeEditing() {
      // @ts-expect-error TS(4111): Property 'spangleMode' comes from an index signatu... Remove this comment to see the full error message
      return this.spangleMode === SPANGLE_MODES.editSize;
    },
    spangleSizeEdited() {
      // @ts-expect-error TS(4111): Property 'spangleMode' comes from an index signatu... Remove this comment to see the full error message
      return this.spangleMode === SPANGLE_MODES.sizeEdited;
    },
    spanglesLoading() {
      // @ts-expect-error TS(4111): Property 'spangleMode' comes from an index signatu... Remove this comment to see the full error message
      return this.spangleMode === SPANGLE_MODES.spanglesLoading;
    },
    isInitialSpangle() {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      return this.spangleVariations.length === 0;
    },
    allAPIsCompleted() {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      return this.spangleVariations.every((variation: any) => !variation.isLoading);
    },
    allAPIsFailed() {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      return this.spangleVariations.every(
        (variation: any) => !variation.isLoading && variation.error
      );
    },
    isSelectedVersionLoading() {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const selectedVersion = this.spangleVariations.find(
        // @ts-expect-error TS(4111): Property 'selectedAlgorithm' comes from an index s... Remove this comment to see the full error message
        (variation: any) => variation.algorithm === this.selectedAlgorithm
      );
      return selectedVersion?.isLoading;
    },
    selectedVersion() {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      return this.spangleVariations.find(
        // @ts-expect-error TS(4111): Property 'selectedAlgorithm' comes from an index s... Remove this comment to see the full error message
        (variation: any) => variation.algorithm === this.selectedAlgorithm
      );
    },
    isFirstSpangle() {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      return this.spangleVariations.length === 0;
    }
  },

  actions: {
    setSpangleMode(mode) {
      // @ts-expect-error TS(4111): Property 'spangleMode' comes from an index signatu... Remove this comment to see the full error message
      this.spangleMode = mode;
    },
    setSpangleVariations(variations) {
      // @ts-expect-error TS(4111): Property 'spangleVariations' comes from an index s... Remove this comment to see the full error message
      this.spangleVariations = variations;
    },
    setLastSpangledDimensions(dimensions) {
      // @ts-expect-error TS(4111): Property 'lastSpangledDimensions' comes from an in... Remove this comment to see the full error message
      this.lastSpangledDimensions = { ...dimensions };
    },
    setSelectedAlgorithm(algorithm) {
      // @ts-expect-error TS(4111): Property 'selectedAlgorithm' comes from an index s... Remove this comment to see the full error message
      this.selectedAlgorithm = algorithm;
    },
    setOriginalArtworkUrl(url) {
      // @ts-expect-error TS(4111): Property 'originalArtworkUrl' comes from an index ... Remove this comment to see the full error message
      this.originalArtworkUrl = url;
    },
    setInvalidSpangleSelected(invalid) {
      // @ts-expect-error TS(4111): Property 'invalidSpangleSelected' comes from an in... Remove this comment to see the full error message
      this.invalidSpangleSelected = invalid;
    },
    setIsSpangleReordering(isSpangleReordering) {
      // @ts-expect-error TS(4111): Property 'isSpangleReordering' comes from an index... Remove this comment to see the full error message
      this.isSpangleReordering = isSpangleReordering;
    },
    resetSpangles() {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.$reset();
    },
    addCompletedSpangleData(data) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.completedSpangleData.push(data);
    },
    resetCompletedSpangleData() {
      // @ts-expect-error TS(4111): Property 'completedSpangleData' comes from an inde... Remove this comment to see the full error message
      this.completedSpangleData = [];
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { version }: { version: a... Remove this comment to see the full error message
    selectVersion({ version }) {
      if (!version) return;
      const store = dtfStore;
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setSelectedAlgorithm(version.algorithm);

      if (version.isLoading) return;

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setInvalidSpangleSelected(version.error);
      // @ts-expect-error TS(4111): Property 'originalArtworkUrl' comes from an index ... Remove this comment to see the full error message
      const imageUrl = version.error ? this.originalArtworkUrl : version.imageUrl;

      store.updateArtworkValues({
        index: 0,
        spangleCsv: version.spangleCsv,
        spanglePagesInfo: version.spanglePagesInfo,
        spanglePositionsJson: version.positionsJson,
        spangledImageUrl: imageUrl
      });
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { isRetry }: { isRetry: a... Remove this comment to see the full error message
    prepareVariations({ isRetry }) {
      const {
        spangleVariations,
        selectedAlgorithm,
        allAPIsFailed,
        isFirstSpangle,
        isSpangleReordering
      } = this;
      const { spangleAlgorithms } = dtfStore;

      let variationsObject = [];

      if (isRetry) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        variationsObject = spangleVariations.map((variation: any) => {
          if (variation.algorithm === selectedAlgorithm || allAPIsFailed) {
            return {
              ...defaultVariation,
              algorithm: variation.algorithm,
              spanglePagesInfo: variation.spanglePagesInfo
            };
          }
          return variation;
        });
      } else {
        const isFreshCall = isFirstSpangle || isSpangleReordering;
        const algorithmList = isFreshCall ? spangleAlgorithms : spangleVariations;
        variationsObject = algorithmList.map((item: any) => ({
          ...(isFreshCall ? defaultVariation : item),
          algorithm: isFreshCall ? item : item.algorithm,
          spanglePagesInfo: isFreshCall ? null : item.spanglePagesInfo,
          isLoading: true
        }));
      }

      if (!selectedAlgorithm || isSpangleReordering) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.setSelectedAlgorithm(variationsObject[0].algorithm);
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setSpangleVariations(variationsObject);
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { spangle }: { spangle: a... Remove this comment to see the full error message
    updateSpangleVersion({ spangle }) {
      const { spangleVariations } = this;

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const updatedList = spangleVariations.map((variation: any) =>
        variation.algorithm === spangle.algorithm
          ? { ...variation, ...spangle, isLoading: false }
          : variation
      );

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setSpangleVariations(updatedList);
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { colorValues }: { colorV... Remove this comment to see the full error message
    // eslint-disable-next-line max-lines-per-function
    changeColor({ colorValues }) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const variationToUpdate = this.spangleVariations.filter(
        ({ isLoading, error, spanglePagesInfo }: any) => {
          const variationColorCount = spanglePagesInfo
            ? Object.values(spanglePagesInfo).filter(color => typeof color === "object").length
            : 0;

          const colorValuesCount = Object.keys(colorValues).length;

          return !isLoading && !error && colorValuesCount === variationColorCount;
        }
      );

      if (variationToUpdate.length === 0) return;

      /* eslint-disable camelcase */
      // eslint-disable-next-line max-lines-per-function
      variationToUpdate.map((variation: any) => {
        const { total_beads_count, time_taken } = variation.spanglePagesInfo;

        return api.dtf
          .updateSpangleColor({
            positions_json: variation.positionsJson,
            pages_info: {
              ...colorValues,
              total_beads_count,
              time_taken
            }
          })
          .then((result: any) => {
            const store = dtfStore;
            const imageUrl = result.design_url || result.design_base64;
            const hasValidImage = Boolean(imageUrl);
            const effectiveImageUrl = hasValidImage ? imageUrl : variation.imageUrl;

            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            this.updateSpangleVersion({
              spangle: {
                ...variation,
                imageUrl: effectiveImageUrl,
                ...(result.pages_info ? { spanglePagesInfo: result.pages_info } : {}),
                ...(result.positions_json ? { positionsJson: result.positions_json } : {}),
                error: !effectiveImageUrl
              }
            });

            // @ts-expect-error TS(4111): Property 'selectedAlgorithm' comes from an index s... Remove this comment to see the full error message
            if (variation.algorithm === this.selectedAlgorithm && hasValidImage) {
              store.updateArtworkValues({
                index: 0,
                spangled: true,
                spangledImageUrl: effectiveImageUrl,
                ...(result.pages_info ? { spanglePagesInfo: result.pages_info } : {}),
                ...(result.positions_json ? { spanglePositionsJson: result.positions_json } : {})
              });
            }
          })
          .catch((error: any) => {
            window.Honeybadger?.notify("DTF spangle color change error", {
              params: {
                error_message: error.message,
                algorithm: variation.algorithm,
                pages_info: colorValues
              }
            });
          });
      });
      /* eslint-enable camelcase */
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { algorithm, spanglePages... Remove this comment to see the full error message
    getVariation({
      algorithm,
      spanglePagesInfo,
      id,
      algorithmsSize,
      algorithmToAnimate,
      processTimeStamp
    }) {
      const { artworks, cable } = dtfStore;

      /* eslint-disable no-underscore-dangle */
      cable.spangle({
        id,
        version_identifier: algorithm,
        pages_info: spanglePagesInfo,
        algorithms_size: algorithmsSize,
        algorithm_to_animate: algorithmToAnimate,
        process_time_stamp: processTimeStamp,
        width: artworks[0].width,
        height: artworks[0].height
      });
      /* eslint-enable no-underscore-dangle */
    },
    /* eslint-enable max-lines-per-function */
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { isRetry, processTimeSta... Remove this comment to see the full error message
    getSpangleVariations({ isRetry, processTimeStamp }) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.resetCompletedSpangleData();
      const { artworks, spangleAlgorithms } = dtfStore;

      if (!spangleAlgorithms.length) {
        return;
      }

      const { id } = artworks[0];

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.prepareVariations({ isRetry });

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setSpangleMode(SPANGLE_MODES.spanglesLoading);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setInvalidSpangleSelected(false);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setIsSpangleReordering(false);

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const algorithmsToCall = this.spangleVariations.filter(({ isLoading }: any) => isLoading);

      algorithmsToCall.map(({ algorithm, spanglePagesInfo }: any) =>
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.getVariation({
          algorithm,
          spanglePagesInfo,
          id,
          algorithmsSize: algorithmsToCall.length,
          algorithmToAnimate: algorithmsToCall[0].algorithm,
          processTimeStamp
        })
      );
    },
    showSpangleResult() {
      const { artworks, updateArtworkValues } = dtfStore;

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setLastSpangledDimensions({
        width: artworks[0]?.width,
        height: artworks[0]?.height
      });

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.completedSpangleData.forEach((data: any) => {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updateSpangleVersion({ spangle: data });
      });

      // We want to select the first successful spangled algorithm
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const firstSuccessfuleSpangle = this.spangleVariations.find((data: any) => !data.error);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.selectVersion({ version: firstSuccessfuleSpangle });

      updateArtworkValues({ index: 0, isLoading: false });
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { artwork }: { artwork: a... Remove this comment to see the full error message
    cancelSpangleProcess({ artwork }) {
      const { lastSpangledDimensions, spangleVariations, updateArtworkValuesById } = dtfStore;
      const updatedList = spangleVariations.map((variation: any) => ({
        ...variation,
        isLoading: false
      }));

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setSpangleVariations(updatedList);
      updateArtworkValuesById({
        id: artwork.id,
        width: parseFloat(lastSpangledDimensions.width),
        height: parseFloat(lastSpangledDimensions.height)
      });

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setSpangleMode(SPANGLE_MODES.sizeEdited);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.resetCompletedSpangleData();
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { artwork }: { artwork: a... Remove this comment to see the full error message
    async cancelArtworkProcess({ artwork }) {
      api.dtf.cancelArtworkProcess({ id: artwork.id });
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setSpangleMode(SPANGLE_MODES.sizeEdited);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.resetCompletedSpangleData();
    }
  }
});

// @ts-expect-error TS(2339): Property 'store' does not exist on type '() => Sto... Remove this comment to see the full error message
export const spanglesStore = useSpanglesStore.store;
